<div class="content center-align">
  <h1>
    <mat-icon class="title-icon">bug_report</mat-icon>
    404
  </h1>
  <h2 i18n="Page Not Found|Page Not Found title@@page-not-found-title">Page not found</h2>
  <h4>
    <ng-container i18n="Page Not Found|Page Not Found explanation@@page-not-found-explanation">
      We're sorry, the page you requested could not be found.
    </ng-container>
    <br/>
    <br/>
    <ng-container i18n="Page Not Found|Home page prompt@@page-not-found-home-page-prompt">Please go back to
    </ng-container>

    <app-link [routerLink]="homeUrl"
              class="link"
              label="Home Page"
              i18n-label="Page Not Found|Home Page link label@@page-not-found-home-page-link-prompt"></app-link>

    <ng-container i18n="Page Not Found|Contact us prompt@@page-not-found-contact-us-prompt">or contact us at
    </ng-container>

    <app-link [href]="supportEmail"
              class="link"
              [label]="supportEmailLabel"
              [external]="true"></app-link>
  </h4>
</div>
